// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
function IconLoading(Props) {
  var sizeOpt = Props.size;
  var className = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : 16;
  var tmp = {
    height: CSS$Showside.intToPx(size),
    width: CSS$Showside.intToPx(size),
    version: "1.1",
    viewBox: "0 0 132 58",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("style", undefined, "@keyframes QVTW__fade-in-out{\n		0%{\n			opacity: 0;\n		}\n		50%{\n			opacity: 1;\n		}\n		100%{\n			opacity: 0;\n		}\n		}"), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("circle", {
    style: {
      opacity: "0.5",
      animation: "QVTW__fade-in-out 1s infinite"
    },
    cx: "25",
    cy: "30",
    r: "13"
  }), React.createElement("circle", {
    style: {
      opacity: "1",
      animation: "QVTW__fade-in-out 1s infinite",
      animationDelay: "0.2s"
    },
    cx: "65",
    cy: "30",
    r: "13"
  }), React.createElement("circle", {
    style: {
      opacity: "0.5",
      animation: "QVTW__fade-in-out 1s infinite",
      animationDelay: "0.4s"
    },
    cx: "105",
    cy: "30",
    r: "13"
  }))));
}
IconLoading.displayName = "IconLoading";
var make = IconLoading;
export { make };
/* react Not a pure module */